import { useEffect } from "react";
import useAsync from "./useAsync";
import { fetchConfig } from "../api/auth";

export default () => {
  const { execute, value, pending } = useAsync(fetchConfig);

  // execute 的參照每次 render 都會變（useAsync 的 callback 預設值不穩定），只需在 mount 時抓一次
  useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // 尚未取得設定前先隱藏入口，避免關閉時按鈕閃現
    registrationEnabled: value ? value.data.registrationEnabled : false,
    loaded: !pending && value !== null,
  };
};
